import {createContext, useState} from 'react';
export const ServicesContext = createContext();

export const data = [
    {
        title: 'AUTOEVALUACION DE ESTANDARES MINIMOS ANTE MINTRABAJO',
        content:`Nuestro Servicio Incluye:\n
        Auditoría Express de Evidencias: No solo subimos números; verificamos que tengas el soporte documental para sustentar cada estándar calificado.\n
        Cargue en Plataforma MinTrabajo: Gestión completa del registro en el portal oficial, asegurando que la información sea recibida sin errores técnicos.\n
        Plan de Mejora Inmediato: Si tu puntaje es inferior al 100%, entregamos la hoja de ruta legal requerida para alcanzar el cumplimiento total.\n
        Certificado de Cumplimiento: Entrega del soporte de radicación oficial para tu archivo de gestión y para presentar a tus clientes o ARL.\n
        `,
        image: 'images/registro_esmin.jpeg'
    },
    {
        title: 'DISEÑO DE DOCUMENTOS DEL SG-SST',
        content: 'Según el Decreto 1072/15, todas las empresas deben tener diseñado el Sistema de Gestión de Seguridad y Salud en el Trabajo, evita sanciones.',
        image: 'images/servicio1.jpeg'
    },
    {
        title: 'IMPLEMENTACIÓN DEL SG-SST',
        content: 'Implementación de seguridad y salud en el trabajo le ayudará a garantizar que su empresa cumple con todos los estándares legales, así como con los estándares de seguridad y salud. Esto significa que sus empleados estarán seguros y protegidos, y su empresa no tendrá que enfrentar posibles sanciones o multas por incumplimiento de la legislación.',
        image: 'images/servicio2.jpeg'
    },
    {
        title: 'INSPECCIONES DE SEGURIDAD',
        content: 'Al realizar las inspecciones de seguridad en su Negocio,se pueden identificar y analizar todos los peligros de accidente, de enfermedades profesionales, los malos procedimientos que el trabajador puede hacer, las posibles condiciones peligrosas en los puestos de trabajo  para después corregirlos.',
        image: 'images/servicio3.jpeg'
    },
    {
        title: 'CAPACITACIONES EN SST',
        content: 'En todo Negocio, la capacitación es la base para prevenir accidentes y enfermedades. De esta forma, los colaboradores conocen los pasos a seguir para garantizar su seguridad y la de los demás.',
        image: 'images/servicio4.jpeg'
    },
    {
        title: 'AUDITORÍAS INTERNAS EN SST y PESV',
        content: 'El cumplimiento de los requisitos del SG-SST, no sólo ayudará a prevenir accidentes laborales, sino que también evita que la organización tenga que hacer frente a multas por el incumplimiento en material legal sobre seguridad y salud en el trabajo.',
        image: 'images/servicio5.jpeg'
    },
    {
        title: 'INVESTIGACIÓN DE ACCIDENTES DE TRABAJO',
        content: 'Evita sanciones y efectúa una adecuada investigación de accidentes de trabajo.',
        image: 'images/servicio6.jpeg'
    },
    // {
    //     title: 'VENTA DE DOTACIÓN Y ELEMENTOS DE PROTECCIÓN PERSONAL',
    //     content: 'Protege a tus trabajadores con E.P.Ps de calidad para que puedan dar su mejor rendimiento sin poner en riesgo su salud.',
    //     image: 'images/venta-dotacion.jpeg'
    // },
    {
        title: 'PLAN ESTRATÉGICO DE SEGURIDAD VIAL',
        content: 'PESV “Es una herramienta de gestión que contiene las acciones, mecanismos, estrategias y medidas de planificación, implementación, seguimiento y mejora que deben aportar las diferentes entidades, organizaciones o empresas del sector público o privado encaminadas a generar hábitos, comportamientos y conductas seguras en las vías para prevenir riesgos, reducir la accidentalidad vial y disminuir sus efectos nocivos”. resolución 20223040040595',
        image: 'images/plan-estrategico-sv.jpeg'
    },
    {
        title: 'MENTORÍA PARA PROFESIONALES EN SST',
        content: 'Fortalece tus competencias técnicas y de liderazgo en Seguridad y Salud en el Trabajo. Recibe acompañamiento experto para la resolución de dudas en implementación, auditoría y gestión estratégica, permitiéndote destacar profesionalmente y asegurar el cumplimiento efectivo en cualquier organización.',
        image: 'images/servicio7.jpeg'
    }
    // {
    //     title: 'GESTIÓN AMBIENTAL',
    //     content: 'Un Sistema de Gestión Ambiental (SGA) es una herramienta que incluye diferentes procesos y prácticas para reducir el impacto ambiental de una empresa y desempeñar su actividad de forma respetuosa con el medio. Incluye tanto la gestión de residuos como la del agua, consumo energético, emisiones de CO2, etc. Implementación ISO 14001',
    //     image: 'images/gestion-ambiental.jpeg'
    // },
    // {
    //     title: 'BATERÍA RIESGO PSICOSOCIAL',
    //     content: 'Resolución 2764 de 2022. Batería Riesgo Psicosocial es una herramienta que le permite evaluar el riesgo intralaboral, extralaboral y el estrés al que se enfrenta su colaborador. La aplicación de este instrumento y el análisis de los resultados que realice un psicólogo ocupacional permitirán determinar el programa a seguir en su compañía.',
    //     image: 'images/bateria-riesgo-psicosocial.jpeg'
    // },
    // {
    //     title: 'DISEÑO E IMPLEMENTACIÓN DEL SISTEMA DE GESTIÓN DE CALIDAD ISO 9001',
    //     content: 'Diseño e implementación del sistema de gestión de calidad ISO 9001',
    //     image: 'images/iso9001.jpeg'
    // },
]

export const ServicesProvider = ({ children }) => {
    const [services, setServices] = useState(data);

    const swapPosition = (index1, index2) => {
        [services[index1], services[index2]] = [services[index2], services[index1]];
        //services.push({title:"1",content:"2",image:"3"})
        setServices(services);
    }
    
    return (
        <ServicesContext.Provider value={{ services, setServices }}>
            {children}
        </ServicesContext.Provider>
    );
}